import { Barcode, Create, Edit, List, ListDemo, RemovedStockItem, BarcodeSingle } from "../Components/index.js";

export default [
    {
        path: "/canteen/inventory/remote-item",
        component: List,
        name: "canteen-inventory-remote-item",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/remote-item-demo",
        component: ListDemo,
        name: "canteen-inventory-remote-item-demo",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/remote-item-removed",
        component: RemovedStockItem,
        name: "canteen-inventory-remote-item-removed",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/remote-barcode/show",
        component: Barcode,
        name: "canteen-inventory-remote-barcode",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/remote-barcode-show/:id",
        component: BarcodeSingle,
        name: "canteen-inventory-remote-barcode-show",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/remote-item/create",
        component: Create,
        name: "canteen-inventory-remote-item-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/remote-multi-item/create",
        component: () => import("../Components/MultiCreate.vue"),
        name: "canteen-inventory-remote-multi-item-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/canteen/inventory/remote-item/:id/edit",
        component: Edit,
        name: "canteen-inventory-remote-item-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/canteen/inventory/update-item",
        component: () => import("@/App/Canteen/Inventory/RemoteItem/Components/UpdateList.vue"),
        name: "canteen-inventory-update-item",
        meta: {
            requiresAuth: true,
        },
    },
];
